import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  query UserDetails {\n    me {\n      ...User\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  query OrderByToken($token: UUID!, $languageCode: LanguageCodeEnum!) {\n    orderByToken(token: $token) {\n      ...OrderDetail\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
import { userFragment } from "../fragments/auth";
import { orderDetailFragment } from "../fragments/user";
export var orderDetailsByTokenQuery = gql(_templateObject(), orderDetailFragment);
export var getUserDetailsQuery = gql(_templateObject2(), userFragment);